(function() {
  /* ========== DATA ========== */
  var sizingData = {
    'XXS': { breeds: 'Chihuahuas, Toy Poodles, Yorkies, Papillons', weight: '' },
    'XS': { breeds: 'Toy Cavoodles, Jack Russells, Miniature Dachshunds, Shih Tzus', weight: '' },
    'S': { breeds: 'Cavoodles, French Bulldogs, Pugs, Cavaliers', weight: '' },
    'M': { breeds: 'Staffies, Cocker Spaniels, Beagles, Kelpies', weight: '' },
    'L': { breeds: 'Golden Retrievers, Labradors, German Shepherds, Huskies', weight: '' }
  };

  var breedToKey = {
    'chihuahuas': 'chihuahua', 'toy poodles': 'toy-poodle', 'yorkies': 'yorkie',
    'papillons': 'papillon', 'toy cavoodles': 'toy-cavoodle-v2', 'jack russells': 'jack-russell',
    'miniature dachshunds': 'mini-dachshund', 'miniature dachshunds': 'mini-dachshund',
    'shih tzus': 'shih-tzu', 'cavoodles': 'cavoodle', 'cavoodles': 'cavoodle',
    'french bulldogs': 'french-bulldog', 'pugs': 'pug', 'cavaliers': 'cavalier',
    'staffies': 'staffy', 'cocker spaniels': 'cocker-spaniel', 'beagles': 'beagle',
    'kelpies': 'kelpie', 'golden retrievers': 'golden-retriever', 'labradors': 'labrador',
    'german shepherds': 'german-shepherd', 'huskies': 'husky'
  };

  var breedDisplayName = {
    'chihuahuas': 'Chihuahua', 'toy poodles': 'Toy Poodle', 'yorkies': 'Yorkie',
    'papillons': 'Papillon', 'toy cavoodles': 'Toy Cavoodle', 'jack russells': 'Jack Russell',
    'miniature dachshunds': 'Miniature Dachshund', 'miniature dachshunds': 'Miniature Dachshund',
    'shih tzus': 'Shih Tzu', 'cavoodles': 'Cavoodle', 'cavoodles': 'Cavoodle',
    'french bulldogs': 'Frenchie', 'pugs': 'Pug', 'cavaliers': 'Cavalier',
    'staffies': 'Staffy (smaller)', 'cocker spaniels': 'Cocker', 'beagles': 'Beagle',
    'kelpies': 'Kelpie', 'golden retrievers': 'Golden', 'labradors': 'Labrador',
    'german shepherds': 'Shepherd', 'huskies': 'Husky'
  };

  /* ========== STYLES ========== */
  var style = document.createElement('style');
  style.textContent = '' +
    '.sizing-helper { margin-top: 12px; }' +
    '.sizing-helper__inner { background: #f8f8f8; border-radius: 10px; padding: 12px 14px 14px; border: 2px solid #F7E5E9; }' +
    '.sizing-helper__breeds { margin: 0 0 12px; font-size: 14px; color: #5a5550; line-height: 1.5; }' +
    '.sizing-helper__breed-names { font-weight: 1000; color: #242424; }' +
    '.sizing-helper__weight { color: #8a8078; }' +
    '.sizing-helper__thumbnails { display: flex; justify-content: center; gap: 16px; margin-bottom: 12px; padding: 0 4px; }' +
    '.sizing-helper__thumb { display: flex; flex-direction: column; align-items: center; gap: 4px; min-width: 0; }' +
    '.sizing-helper__thumb-circle { width: 64px; height: 64px; border-radius: 50%; overflow: hidden; border: 2px solid #F7E5E9; background: #f8f6f3; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }' +
    '.sizing-helper__thumb-circle img { width: 64px; height: 64px; object-fit: cover; object-position: center 60%; }' +
    '.sizing-helper__thumb-name { font-size: 11.5px; color:rgb(20, 20, 20); text-align: center; line-height: 1.2; max-width: 72px; word-wrap: break-word; white-space: normal; }' +
    '.sizing-helper__gallery-link { display: flex; align-items: center; justify-content: center; gap: 6px; width: 100%; padding: 9px 0; background: #FDEEF1; border: 1px solid #f9abb5; border-radius: 6px; color: #c4566b; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.15s ease; font-family: inherit; }' +
    '.sizing-helper__gallery-link:hover { background: #fbe0e6; border-color: #f48fa0; }' +
    '.sizing-helper__disclaimer { margin: 10px 0 0; font-size: 14px; color: #333333ff; text-align: center; line-height: 1.4; }' +
    '.sizing-helper__prompt { margin: 10px 0 0; font-size: 13px; color: #b0a8a0; text-align: center; font-style: italic; }' +
    '.sizing-helper__thumbnails:empty { display: none; margin: 0; }' +
    'fieldset.product-form__input--pill label .visually-hidden + span, fieldset.product-form__input--pill input.disabled + label { text-decoration: none !important; }' +
    '.product-form__input--pill legend.form__label { font-size: 15px !important; font-weight: 500 !important; }' +
    '.product-form__input--pill legend.form__label { font-size: 15px !important; font-weight: 500 !important; }';
  document.head.appendChild(style);

  /* ========== STATE ========== */
  var lastSize = null;
  var hasClicked = false;

  /* ========== BUILD HTML ========== */
  function createHelper() {
    var wrapper = document.createElement('div');
    wrapper.className = 'sizing-helper';
    wrapper.id = 'sizing-helper-persistent';
    wrapper.style.display = 'none';
    wrapper.innerHTML = '' +
      '<div class="sizing-helper__inner">' +
        '<p class="sizing-helper__breeds">' +
          'Fits <span class="sizing-helper__breed-names"></span> ' +
          'and similar breeds ' +
          '<span class="sizing-helper__weight"></span>' +
        '</p>' +
        
        '<div class="sizing-helper__thumbnails"></div>' +
        '<button type="button" class="sizing-helper__gallery-link">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<rect x="3" y="3" width="7" height="7" rx="1"></rect>' +
            '<rect x="14" y="3" width="7" height="7" rx="1"></rect>' +
            '<rect x="3" y="14" width="7" height="7" rx="1"></rect>' +
            '<rect x="14" y="14" width="7" height="7" rx="1"></rect>' +
          '</svg>' +
          '<span>See real dogs wearing size <span class="sizing-helper__size-label"></span></span>' +
          '<span>&rarr;</span>' +
        '</button>' +
        '<p class="sizing-helper__disclaimer">Breeds vary - confirm with the size chart</p>' +
      '</div>';

    wrapper.querySelector('.sizing-helper__gallery-link').addEventListener('click', function() {
      var gallery = document.getElementById('sizing-gallery') || document.querySelector('[data-sizing-gallery]');
      if (gallery) gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    return wrapper;
  }

  function createPrompt() {
    var p = document.createElement('p');
    p.className = 'sizing-helper__prompt';
    p.id = 'sizing-helper-prompt-persistent';
    p.textContent = 'Select a size to see which breeds it fits';
    return p;
  }

  /* ========== FIND SIZE FIELDSET ========== */
  function findSizeFieldset() {
    var fieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && legend.textContent.trim().toLowerCase().indexOf('size') === 0) {
        return fieldsets[i];
      }
    }
    return null;
  }








function ensureInjected() {
    var existing = document.getElementById('sizing-helper-persistent');
    var existingPrompt = document.getElementById('sizing-helper-prompt-persistent');
    var sizeFieldset = findSizeFieldset();

    if (!sizeFieldset) return;

    if (!existing) {
      existing = createHelper();
      sizeFieldset.parentNode.insertBefore(existing, sizeFieldset.nextSibling);
    } else if (!sizeFieldset.parentNode.contains(existing)) {
      sizeFieldset.parentNode.insertBefore(existing, sizeFieldset.nextSibling);
    }

    if (!existingPrompt) {
      existingPrompt = createPrompt();
      existing.parentNode.insertBefore(existingPrompt, existing.nextSibling);
    } else if (!sizeFieldset.parentNode.contains(existingPrompt)) {
      existing.parentNode.insertBefore(existingPrompt, existing.nextSibling);
    }

    if (hasClicked && lastSize) {
      updateContent(existing, lastSize);
      existing.style.display = '';
      existingPrompt.style.display = 'none';
    }

    /* Update Size label */
    if (lastSize) {
      var sizeLegend = sizeFieldset.querySelector('legend');
      if (sizeLegend) sizeLegend.innerHTML = 'Size: <span style="font-weight:600">' + lastSize + '</span>';
    }

    /* Style all pill buttons via JS */
    var allFieldsets = document.querySelectorAll('fieldset.product-form__input--pill');
    allFieldsets.forEach(function(fs) {
      var labels = fs.querySelectorAll('label');
      var inputs = fs.querySelectorAll('input[type="radio"]');
      inputs.forEach(function(inp) {
        var lbl = fs.querySelector('label[for="' + inp.id + '"]');
        if (!lbl) return;
        lbl.style.borderRadius = '0';
        lbl.style.fontWeight = '500';
        if (inp.checked) {
          lbl.style.border = '2px solid #f9abb5';
          lbl.style.background = 'transparent';
          lbl.style.color = '#1a1a1a';
        } else {
          lbl.style.border = '1.5px solid #ddd';
          lbl.style.background = 'transparent';
          lbl.style.color = '#555';
        }
        if (inp.classList.contains('disabled')) {
          lbl.style.opacity = '0.5';
          lbl.style.position = 'relative';
          lbl.style.overflow = 'hidden';
          lbl.style.verticalAlign = 'top';
          if (!lbl.querySelector('.size-strikethrough')) {
            var line = document.createElement('div');
            line.className = 'size-strikethrough';
            line.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;';
            line.innerHTML = '<svg width="100%" height="100%" style="position:absolute;top:0;left:0"><line x1="100%" y1="0" x2="0" y2="100%" stroke="#999" stroke-width="1.5"/></svg>';
            lbl.appendChild(line);
          }
        }
      });
    });
  }

  /* ========== UPDATE CONTENT ========== */
  function updateContent(el, sizeValue) {
    var data = sizingData[sizeValue];
    if (!data || !data.breeds) {
      el.style.display = 'none';
      return;
    }

    el.querySelector('.sizing-helper__breed-names').textContent = data.breeds;
    el.querySelector('.sizing-helper__weight').textContent = data.weight ? '(' + data.weight + ')' : '';
    el.querySelector('.sizing-helper__size-label').textContent = sizeValue;

    var thumbContainer = el.querySelector('.sizing-helper__thumbnails');
    thumbContainer.innerHTML = '';

    var breeds = data.breeds.split(',');
    for (var i = 0; i < breeds.length; i++) {
      var breedRaw = breeds[i].trim();
      var breedLower = breedRaw.toLowerCase();
      var silKey = breedToKey[breedLower];
      var displayName = breedDisplayName[breedLower] || breedRaw;

      var thumb = document.createElement('div');
      thumb.className = 'sizing-helper__thumb';

      var circle = document.createElement('div');
      circle.className = 'sizing-helper__thumb-circle';

      if (silKey) {
        var img = document.createElement('img');
        img.src = '/cdn/shop/files/silhouette-' + silKey + '.webp?width=200';
        img.alt = displayName;
        img.loading = 'lazy';
        img.onerror = function() { this.style.display = 'none'; };
        circle.appendChild(img);
      }

      var nameEl = document.createElement('span');
      nameEl.className = 'sizing-helper__thumb-name';
      nameEl.textContent = displayName;

      thumb.appendChild(circle);
      thumb.appendChild(nameEl);
      thumbContainer.appendChild(thumb);
    }

    el.style.display = '';
  }

  /* ========== EVENT LISTENER ========== */
  document.addEventListener('change', function(e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;

    var fieldset = input.closest('fieldset, .product-form__input');
    if (!fieldset) return;

    var legend = fieldset.querySelector('legend, .form__label');
    if (!legend) return;

    if (legend.textContent.trim().toLowerCase().indexOf('size') !== 0) return;

    lastSize = input.value;
    hasClicked = true;







    /* Immediately style buttons before Dawn re-renders */
    var fs = input.closest('fieldset');
    if (fs) {
      fs.querySelectorAll('input[type="radio"]').forEach(function(inp) {
        var lbl = fs.querySelector('label[for="' + inp.id + '"]');
        if (!lbl) return;
        lbl.style.borderRadius = '0';
        lbl.style.fontWeight = '500';
        if (inp.checked) {
          lbl.style.border = '2px solid #d4a0a0';
          lbl.style.background = 'transparent';
          lbl.style.color = '#1a1a1a';
        } else {
          lbl.style.border = '1.5px solid #ddd';
          lbl.style.background = 'transparent';
          lbl.style.color = '#555';
        }
        if (inp.classList.contains('disabled')) {
          lbl.style.opacity = '0.5';
          lbl.style.position = 'relative';
          lbl.style.overflow = 'hidden';
          lbl.style.verticalAlign = 'top';
          if (!lbl.querySelector('.size-strikethrough')) {
            var line = document.createElement('div');
            line.className = 'size-strikethrough';
            line.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;';
            line.innerHTML = '<svg width="100%" height="100%" style="position:absolute;top:0;left:0"><line x1="100%" y1="0" x2="0" y2="100%" stroke="#999" stroke-width="1.5"/></svg>';
            lbl.appendChild(line);
          }
        }
      });
    }

    /* Only inject after Dawn finishes re-rendering */
    setTimeout(ensureInjected, 800);







   /* Only inject after Dawn finishes re-rendering */
    setTimeout(ensureInjected, 100);
  });

  /* ========== INITIAL INJECTION ========== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureInjected);
  } else {
    ensureInjected();
  }




})();